import { Row, Col } from "antd";
import FullLogo from "assets/Images/Header/FullLogo.svg";
import BlackSLogo from "assets/Images/Header/BlackSLogo.svg";
import Search from "./Components/Serach/Search";
import Options from "./Components/Options/Options";
import CategoryIndex from "./Components/CategoryIndex";
import { Link } from "react-router-dom";
import LazyLoadImage from "apps/Common/LazyLoadImage";
import MobileIndex from "./Mobile";
import MobileSearch from "./Components/Serach/MobileSearch";

const HeaderIndex = () => {
  return (
    <>
      <div
        className=" !py-4 !hidden lg:!block 
      !px-2 lg:!px-6 xxl:!px-16 
      
      shadow-lg !bg-[#FFF] !sticky !top-0 !z-50   "
      >
        <Row gutter={[16, 16]}>
          <Col xs={24} lg={16} xl={16}>
            <Row className="!px-2">
              <Col xs={24} lg={9} xl={7}>
                <div>
                  <Link to="/">
                    <LazyLoadImage
                      wrapperWidth="200px"
                      wrapperHeight="38px"
                      style={{ objectFit: "contain" }}
                      src={FullLogo}
                      alt="Sari ilanlar logosu"
                    />
                  </Link>
                </div>
              </Col>
              <Col xs={24} lg={11} xl={7}>
                <CategoryIndex />
              </Col>
              <Col xs={24} lg={4} xl={10} >
                <div className="!hidden xl:!block">
                  <Search />
                </div>
                <div className="!flex xl:!hidden items-center !h-full">
                  <MobileSearch />
                </div>
              </Col>
            </Row>
          </Col>
          <Col xs={24} lg={8} xl={8} className="!grid items-center">
            <Options />
          </Col>
        </Row>
      </div>

      <div className="!sticky !top-0 !z-50 lg:!hidden">
        <MobileIndex />
      </div>
    </>
  );
};

export default HeaderIndex;
